import { useEffect, useState, useRef } from 'react';

interface Props {
  isHistoryLoading: boolean;
  hideFilters: boolean;
}

const useResizeDrawer = ({ isHistoryLoading, hideFilters }: Props) => {
  const drawerContainerRef = useRef<HTMLDivElement | null>(null);
  const [drawerOpen, setDrawerOpen] = useState<boolean>(true);
  const [drawerHeight, setDrawerHeight] = useState<number>(0);

  // Resize the drawer with the rest of the component
  useEffect(() => {
    const handleResize = () => {
      if (!drawerContainerRef.current) return;
      if (drawerOpen) {
        setDrawerHeight(drawerContainerRef.current.clientHeight);
      } else {
        setDrawerHeight(0);
      }
    };
    handleResize();
    if (window) window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [drawerOpen, isHistoryLoading, hideFilters]);

  return {
    drawerHeight,
    drawerOpen,
    drawerContainerRef,
    setDrawerOpen,
  } as const;
};

export default useResizeDrawer;
